import { Link } from '@tanstack/react-router'
import { Coins } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useMePointsBalance } from '@/shared/api/pointsBalanceQueries'
import { useMePointsBalanceVisible } from '@/shared/hooks/useMePointsBalanceVisible'

export function PointsBalanceBadge() {
  const { t } = useTranslation()
  const visible = useMePointsBalanceVisible()
  const balance = useMePointsBalance({ enabled: visible })

  if (!visible || !balance.isSuccess) {
    return null
  }

  return (
    <Link
      to="/me"
      className="flex items-center gap-1.5 rounded-full border border-border bg-muted/40 px-2 py-1.5 text-sm font-medium text-foreground no-underline hover:bg-muted sm:px-3"
      data-testid="points-balance-badge"
      title={t('app.layout.points_balance_title', { count: balance.data })}
      aria-label={t('app.layout.points_balance_title', { count: balance.data })}
    >
      <Coins className="size-4 text-[var(--v2-brand-ink)]" aria-hidden />
      <span className="hidden sm:inline">{t('app.layout.points_balance_label', { count: balance.data })}</span>
    </Link>
  )
}
